import { combineReducers } from "redux";

import auth from "./Auth/reducer";
import general from "./General/reducer";

const reducers = combineReducers({
  auth,
  general,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }
  return reducers(state, action);
};

export default rootReducer;
